(function () {
  if (window.ZenzooneProductPageLoaded) return;
  window.ZenzooneProductPageLoaded = true;

  function parseJson(root, selector, fallback) {
    var node = root.querySelector(selector);
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return fallback;
    }
  }

  function formatMoney(cents, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }

    var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active
      ? window.Shopify.currency.active
      : "USD";

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: currency
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function initGallery(root) {
    root.querySelectorAll("[data-zz-gallery]:not([data-zz-bound])").forEach(function (gallery) {
      gallery.setAttribute("data-zz-bound", "true");
      var slides = gallery.querySelectorAll("[data-zz-media-id]");
      var thumbs = gallery.querySelectorAll("[data-zz-gallery-thumb]");
      var thumbTrack = gallery.querySelector("[data-zz-thumb-track]");
      var thumbPrev = gallery.querySelector("[data-zz-thumb-prev]");
      var thumbNext = gallery.querySelector("[data-zz-thumb-next]");

      function show(mediaId) {
        slides.forEach(function (slide) {
          var active = slide.getAttribute("data-zz-media-id") === String(mediaId);
          slide.classList.toggle("is-active", active);
          slide.hidden = !active;
        });

        thumbs.forEach(function (thumb) {
          var active = thumb.getAttribute("data-zz-gallery-thumb") === String(mediaId);
          thumb.classList.toggle("is-active", active);
          thumb.setAttribute("aria-selected", active ? "true" : "false");
          if (active && typeof thumb.scrollIntoView === "function") {
            thumb.scrollIntoView({ behavior: "smooth", inline: "nearest", block: "nearest" });
          }
        });
      }

      function scrollThumbs(direction) {
        if (!thumbTrack) return;
        var firstThumb = thumbTrack.querySelector("[data-zz-gallery-thumb]");
        var amount = firstThumb ? firstThumb.getBoundingClientRect().width + 12 : 128;
        thumbTrack.scrollBy({ left: amount * direction * 2, behavior: "smooth" });
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          show(thumb.getAttribute("data-zz-gallery-thumb"));
        });
      });

      if (thumbPrev) thumbPrev.addEventListener("click", function () { scrollThumbs(-1); });
      if (thumbNext) thumbNext.addEventListener("click", function () { scrollThumbs(1); });

      gallery.zzShowMedia = show;
    });
  }

  function initModals(root) {
    root.querySelectorAll("[data-zz-modal-open]:not([data-zz-bound])").forEach(function (button) {
      button.setAttribute("data-zz-bound", "true");
      button.addEventListener("click", function () {
        var modal = document.getElementById(button.getAttribute("data-zz-modal-open"));
        if (!modal) return;
        modal.setAttribute("aria-hidden", "false");
        document.documentElement.classList.add("zz-modal-open");
        var close = modal.querySelector("[data-zz-modal-close]");
        if (close) close.focus();
      });
    });

    root.querySelectorAll("[data-zz-modal]:not([data-zz-close-bound])").forEach(function (modal) {
      modal.setAttribute("data-zz-close-bound", "true");
      modal.querySelectorAll("[data-zz-modal-close]").forEach(function (button) {
        button.addEventListener("click", function () {
          modal.setAttribute("aria-hidden", "true");
          document.documentElement.classList.remove("zz-modal-open");
        });
      });
    });
  }

  function initProductForms(root) {
    root.querySelectorAll("[data-zz-product-root]:not([data-zz-product-bound])").forEach(function (sectionRoot) {
      sectionRoot.setAttribute("data-zz-product-bound", "true");

      var product = parseJson(sectionRoot, "[data-zz-product-json]", null);
      var moneyFormat = parseJson(sectionRoot, "[data-zz-money-format]", "${{amount}}");
      var form = sectionRoot.querySelector("[data-zz-product-form]");
      var sticky = sectionRoot.querySelector("[data-zz-sticky-atc]");
      var stickyButton = sectionRoot.querySelector("[data-zz-submit-for]");
      var gallery = sectionRoot.querySelector("[data-zz-gallery]");

      if (!product || !form) return;

      var variantIdInput = form.querySelector("[data-zz-variant-id]");
      var atc = form.querySelector("[data-zz-atc]");
      var atcText = form.querySelector("[data-zz-atc-text]");
      var priceNodes = sectionRoot.querySelectorAll("[data-zz-price]");
      var compareNodes = sectionRoot.querySelectorAll("[data-zz-compare-price]");
      var stickyPrice = sectionRoot.querySelector("[data-zz-sticky-price]");
      var stickyVariant = sectionRoot.querySelector("[data-zz-sticky-variant]");
      var optionInputs = form.querySelectorAll("[data-zz-option-input]");
      var soldOutText = atc && atc.dataset.zzSoldOutText ? atc.dataset.zzSoldOutText : "Sold out";
      var availableText = atc && atc.dataset.zzAvailableText ? atc.dataset.zzAvailableText : "Add to cart";

      function selectedOptions() {
        return product.options.map(function (_, index) {
          var checked = form.querySelector("[data-option-position='" + (index + 1) + "']:checked");
          return checked ? checked.value : null;
        });
      }

      function findVariant() {
        var selected = selectedOptions();
        return product.variants.find(function (variant) {
          return variant.options.every(function (value, index) {
            return value === selected[index];
          });
        });
      }

      function updateVariant(variant) {
        if (!variant) {
          if (atc) atc.disabled = true;
          if (stickyButton) stickyButton.disabled = true;
          if (atcText) atcText.textContent = soldOutText;
          return;
        }

        if (variantIdInput) variantIdInput.value = variant.id;

        priceNodes.forEach(function (node) {
          node.innerHTML = formatMoney(variant.price, moneyFormat);
        });

        compareNodes.forEach(function (node) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            node.hidden = false;
            node.innerHTML = formatMoney(variant.compare_at_price, moneyFormat);
          } else {
            node.hidden = true;
            node.innerHTML = "";
          }
        });

        if (stickyPrice) stickyPrice.innerHTML = formatMoney(variant.price, moneyFormat);
        if (stickyVariant) stickyVariant.textContent = variant.title;

        if (atc) atc.disabled = !variant.available;
        if (stickyButton) stickyButton.disabled = !variant.available;
        if (atcText) atcText.textContent = variant.available ? availableText : soldOutText;

        if (variant.featured_media && gallery && typeof gallery.zzShowMedia === "function") {
          gallery.zzShowMedia(variant.featured_media.id);
        }

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set("variant", variant.id);
          window.history.replaceState({}, "", url.toString());
        }
      }

      optionInputs.forEach(function (input) {
        input.addEventListener("change", function () {
          updateVariant(findVariant());
        });
      });

      updateVariant(findVariant() || product.variants[0]);

      if (stickyButton) {
        stickyButton.addEventListener("click", function () {
          if (typeof form.requestSubmit === "function") {
            form.requestSubmit();
          } else {
            form.submit();
          }
        });
      }

      if (sticky) {
        if ("IntersectionObserver" in window) {
          var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              sticky.hidden = entry.isIntersecting || window.scrollY < 420;
            });
          }, { threshold: 0.05 });
          observer.observe(form);
        } else {
          window.addEventListener("scroll", function () {
            sticky.hidden = window.scrollY < 650;
          }, { passive: true });
        }
      }
    });
  }

  function initReviewScroll(root) {
    root.querySelectorAll(".zz-review-shell:not([data-zz-scroll-bound])").forEach(function (shell) {
      shell.setAttribute("data-zz-scroll-bound", "true");
      var track = shell.querySelector("[data-zz-scroll-track]");
      var prev = shell.querySelector("[data-zz-scroll-prev]");
      var next = shell.querySelector("[data-zz-scroll-next]");
      if (!track) return;

      function scrollByCard(direction) {
        var amount = track.querySelector(".zz-review-card")
          ? track.querySelector(".zz-review-card").getBoundingClientRect().width + 16
          : 320;
        track.scrollBy({ left: amount * direction, behavior: "smooth" });
      }

      if (prev) prev.addEventListener("click", function () { scrollByCard(-1); });
      if (next) next.addEventListener("click", function () { scrollByCard(1); });
    });
  }

  function init(root) {
    initGallery(root);
    initModals(root);
    initProductForms(root);
    initReviewScroll(root);
  }

  document.addEventListener("DOMContentLoaded", function () {
    init(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    document.querySelectorAll("[data-zz-modal][aria-hidden='false']").forEach(function (modal) {
      modal.setAttribute("aria-hidden", "true");
    });
    document.documentElement.classList.remove("zz-modal-open");
  });
})();
